export const DevelopersTypeDecorator = {
  url() {
    return `signup-hubspot/developers`;
  },
  query() {
    return {};
  }
};